<template>
  <div class="tab-bar">
    <van-tabbar v-model="active" safe-area-inset-bottom>
      <van-tabbar-item
        v-for="(tab, index) in list"
        :icon="tab.icon"
        :key="index"
        :to="tab.path"
        >{{ tab.title }}</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import tabBarList from "./tabBar.js";
import { Toast, Tabbar, TabbarItem } from "vant";

export default {
  name: "NavTabbar",
  comments: {
    Toast,
    Tabbar,
    TabbarItem,
  },
  data() {
    return {
      currentPath: this.$route.path,
      list: tabBarList,
      active: 1,
    };
  },
  watch: {
    $route(newValue) {
      if (newValue) {
        this.currentPath = newValue.path;
        this.list.forEach((tab, index) => {
          if (tab.path == this.currentPath) this.active = index;
        });
      }
    },
  },
  created() {
    this.list.forEach((tab, index) => {
      if (tab.path == this.currentPath) this.active = index;
    });
  },
  methods: {
    handleTabbarClick(item) {
      if (item.disabled) {
        Toast("暂未开放，敬请期待");
        return;
      }
      this.skipToUrl(item);
    },
    // 跳转页面
    skipToUrl(item) {
      if (this.$route.path !== item.path) {
        this.$router.push({
          path: item.path,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
}
</style>
